import { TYPES } from "./default_bailiff.type";

const initState = {
  defaultBailiffAll: null,
  defaultBailiffOpenAdd: false,
  defaultBailiffOpenEdit: false,
  defaultBailiffSelected: null,
  defaultBailiffSearch: "",
  //
  defaultBailiffDetail: null,
};

const defaultBailiffReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_DEFAULT_BAILIFF_DETAIL:
      return {
        ...state,
        defaultBailiffDetail: payload,
      };

    case TYPES.SET_DEFAULT_BAILIFF_ALL:
      return {
        ...state,
        defaultBailiffAll: payload,
      };

    case TYPES.SET_DEFAULT_BAILIFF_OPEN_ADD:
      return {
        ...state,
        defaultBailiffOpenAdd: payload,
      };

    case TYPES.SET_DEFAULT_BAILIFF_OPEN_EDIT:
      return {
        ...state,
        defaultBailiffOpenEdit: payload,
      };

    case TYPES.SET_DEFAULT_BAILIFF_SELECTED:
      return {
        ...state,
        defaultBailiffSelected: payload,
      };

    case TYPES.SET_DEFAULT_BAILIFF_SEARCH:
      return {
        ...state,
        defaultBailiffSearch: payload,
      };

    default:
      return state;
  }
};

export default defaultBailiffReducer;
